import { useMemo } from 'react';

import { useCMSSlider } from '../../hooks';
import { IPromotionProps, Promotion } from './Promotion';
import { Slide } from '@/api/cms';
import { NativeSlider } from '@/components/NativeSlider';
import {
  SliderArrow,
  SliderWithInsideArrows,
} from '@/components/NativeSlider/helpers';
import { useServer } from '@/modules/server/context/ServerEnvContext';

import { ScSliderContainer } from './styled';

interface PromotionsSliderProps {
  promoSlides: Slide[];
}

export const PromotionsSlider: React.FC<PromotionsSliderProps> = ({
  promoSlides,
}) => {
  const { slides } = useCMSSlider(promoSlides);
  const { isMobileDevice } = useServer();

  const sliderProps = useMemo(() => {
    const arrows: SliderWithInsideArrows | undefined = !isMobileDevice
      ? {
          type: SliderArrow.INSIDE,
        }
      : undefined;

    return {
      loop: true,
      pagination: true,
      arrows,
      autoplay: {
        delay: 80000,
        pauseOnMouseEnter: true,
      },
    };
  }, [isMobileDevice]);

  const slidesWithImageProps = useMemo<IPromotionProps[]>(() => {
    return slides.map((slide, index) => ({
      ...slide,
      loading: index === 0 ? 'eager' : 'lazy',
    }));
  }, [slides]);

  return (
    <ScSliderContainer>
      {slides.length ? (
        <NativeSlider<IPromotionProps>
          slides={slidesWithImageProps}
          slide={Promotion}
          {...sliderProps}
        />
      ) : null}
    </ScSliderContainer>
  );
};

export default PromotionsSlider;
